import { render, staticRenderFns } from "./ContractAlertsReportTemplate.vue?vue&type=template&id=580f4762"
import script from "./ContractAlertsReportTemplate.vue?vue&type=script&lang=js"
export * from "./ContractAlertsReportTemplate.vue?vue&type=script&lang=js"
import style0 from "./ContractAlertsReportTemplate.vue?vue&type=style&index=0&id=580f4762&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports